<template>
    <div class="btn-opcoes-reader">
        <Button type="button" icon="pi pi-ellipsis-v" @click="toggle" aria-haspopup="true" text rounded
            aria-controls="overlay_menu" severity="secondary" />
        <Menu ref="menuHeader" id="overlay_menu" :model="items" :popup="true" />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import Button from 'primevue/button';
import Menu from 'primevue/menu';

defineProps({
    items: { type: Array, required: true },
});

const menuHeader = ref();
const toggle = (event) => {
    menuHeader.value.toggle(event);
};
</script>
